// removed by extract-text-webpack-plugin
module.exports = {"wraps":"styles__wraps___25fHg","content-wrap":"styles__content-wrap___20KZn","content-class":"styles__content-class___v7RbI","portal":"styles__portal___Ockic"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/Shell/styles.scss
// module id = 7687
// module chunks = 0